import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfiguration } from 'app/app-configuration';
import { Observable } from 'rxjs';
import { ObjectFindRequestModel } from '@base/modules/rest/object/model/object-find-request.model';

@Injectable()
export class OcenjivanjeRadnikaRestService {
  private readonly controllerUrl: string = this.appConfiguration.serverApiUrl + '/secured/ocenjivanje-radnika';

  constructor(private httpClient: HttpClient,
              private appConfiguration: AppConfiguration) {
  }

  bulkPrint(data: ObjectFindRequestModel): Observable<Blob> {
    return this.httpClient.post(this.controllerUrl + `/bulk-print`, data, {
      responseType: 'blob'
    });
  }
}
